const { ELEMENT_FRAMES } = require("./constants");

const DEFAULT_LANGUAGE = "EN-GB";

const tokensApiUrl = {
  QA: "https://gwc.ckotech.co/vault-proxy/tokens",
  SBOX: "https://api.sandbox.checkout.com/tokens",
  PROD: "https://api.checkout.com/tokens",
};

const riskConfig = {
  QA: {
    riskEndpoint: "https://fpjs.cko-qa.ckotech.co",
    deviceDataEndpoint: "https://prism-qa.ckotech.co/collect",
    riskFrameSrc: "https://prism-qa.ckotech.co/cdn/risk/1.4/agent/index.html",
    timeout: 3000,
  },
  SBOX: {
    riskEndpoint: "https://fpjs.sandbox.checkout.com",
    deviceDataEndpoint: "https://risk.sandbox.checkout.com/collect",
    riskFrameSrc:
      "https://risk.sandbox.checkout.com/cdn/risk/1.4/agent/index.html",
    timeout: 3000,
  },
  PROD: {
    riskEndpoint: "https://fpjs.checkout.com",
    deviceDataEndpoint: "https://risk.checkout.com/collect",
    riskFrameSrc: "https://risk.checkout.com/cdn/risk/1.4/agent/index.html",
    timeout: 10000,
  },
};

const AWS_REGION = "eu-west-1";

const fields = [
  ELEMENT_FRAMES.CARD_NUMBER,
  ELEMENT_FRAMES.EXPIRY_DATE,
  ELEMENT_FRAMES.CVV,
  ELEMENT_FRAMES.SCHEME_CHOICE,
];

const BASE_CALL = 1;
const MAX_RETRIES = 3;

const exponentialBackoffOptions = {
  numOfAttempts: BASE_CALL + MAX_RETRIES,
  startingDelay: 1000,
  timeMultiple: 3,
};

module.exports = {
  tokensApiUrl,
  AWS_REGION,
  fields,
  exponentialBackoffOptions,
  DEFAULT_LANGUAGE,
  riskConfig,
};
